import { Injectable }         from '@angular/core';
import { Location }           from '@angular/common';
import { Title }              from '@angular/platform-browser';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';
import helper                 from '../helper';

@Injectable()
export class MiscService {
  public loadingModal;

  public constructor(
    private location: Location,
    private title: Title,
    private toastController: ToastController,
    private loadingController: LoadingController,
  ) {
    this.setTitle();
  }

  public scrollTop(): void {
    return window.scrollTo(0, 0);
  }

  public setTitle(title?: string): void {
    this.title.setTitle((title && title.length > 0) ? `Dra - ${title}` : `Dra`);
  }
  // public async getRouteParams(route: ActivatedRoute, key?: string): Promise<Params> {
  //   let routeParams = await helper.toPromise(route.params);
  //
  //   return key ? routeParams[key] : routeParams;
  // }
  // public async getRouteData(route: ActivatedRoute, key?: string): Promise<any> {
  //   let data = await helper.toPromise(route.data);
  //
  //   return key ? data[key] : data;
  // }
  public async getUrlParams(key?: string): Promise<any> {
    // let queryParams = await helper.toPromise(this.route.queryParams);
    //
    // return key ? queryParams[key] : queryParams;
  }
  public async setUrlParams(key: string, value: string): Promise<void> {
    let path: string, queryParams: URLSearchParams;
    path = this.getPath();

    queryParams = helper.toQueryParams(await this.getUrlParams());
    queryParams.set(key, value);

    this.location.go(path, queryParams.toString());
  }
  public getPath(): string {
    return helper.substringTo(this.location.path(), '?');
  }

  startLoading(): void {
    if (this.loadingModal) return;
    this.loadingModal = this.loadingController.create({
      content: 'Loading...',
    });
    this.loadingModal.present();
    // this.loading.next(true);
  }
  stopLoading(): void {
    if (!this.loadingModal) return;
    this.loadingModal.dismiss();
    this.loadingModal = undefined;
    // this.loading.next(false);
  }
  success(message?: string, title?: string) {
    this.toastController.create({
      message: message,
      duration: 3000,
      position: 'top',
      showCloseButton: true,
    }).present();
  }
  error(message?: string, title?: string) {
    this.toastController.create({
      message: message,
      position: 'top',
      showCloseButton: true,
    }).present();
  }
  changeUrl(path, params, reload?) {
    let queryString = helper.toQueryParams(params).toString();
    this.location.replaceState(path, queryString);
  }
}



// WEBPACK FOOTER //
// ./src/services/misc.service.ts